import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { partsCatalogue } from "../../../vars/partsCatalogue";
import InfoFooterHeader from "../../atoms/info/InfoFooterHeader/InfoFooterHeader";
import InfoFooterItem from "../../molecules/info/InfoFooterItem/InfoFooterItem";
import InfoFooterSection from "../../atoms/info/InfoFooterSection/InfoFooterSection";
import InfoFooterLink from "../../atoms/info/InfoFooterLink/InfoFooterLink";

const InfoFooter = ({ make, model }) => {
  const [footerLinks, setFooterLinks] = useState(null);

  useEffect(() => {
    setFooterLinks(
      partsCatalogue.find((e) => e.make === make && e.model === model)
    );
  }, []);

  return (
    <StyledSection>
      <Header>{`${footerLinks?.make} ${footerLinks?.model} parts catalogue`}</Header>
      <Flex>
        {footerLinks?.links.map((item, index) => (
          <InfoFooterItem key={index}>
            {item.photo && (
              <StyledImg
                src={item.photo}
                alt={`${footerLinks.make} ${footerLinks.model} parts catalogue`}
              />
            )}
            <InfoFooterSection>
              <InfoFooterHeader>{item.title}</InfoFooterHeader>
              {item.links.map((e, index) => (
                <InfoFooterLink to={e.link} key={index}>
                  {e.name}
                </InfoFooterLink>
              ))}
            </InfoFooterSection>
          </InfoFooterItem>
        ))}
      </Flex>
    </StyledSection>
  );
};

export default InfoFooter;

const StyledSection = styled.section`
  background-color: #222;
  padding: 15px;
  margin: 30px 0;
  border-radius: 5px;
  color: white;
  font-family: "Open Sans";
`;

const Header = styled.div`
  text-align: left;
  color: #fff;
  border-bottom: 2px solid #dc3332;
  padding-bottom: 10px;
  margin: 5px 10px 15px;
  font-size: 22px;
  font-weight: 400;
`;

const Flex = styled.div`
  padding: 0 15px;
  display: flex;
  flex-wrap: wrap;
  line-height: 1.5;
`;

const StyledImg = styled.img`
  height: 80px;
  width: 130px;
`;
